import {useEffect, useRef} from 'react';
import {useAppSelector} from '@/hooks';
import {MODALS_IDS} from '@Components/modal-container';
import {handlePublishModalDismissed, isPublishInFlightForGrowlHandoff} from '@Components/ai-chat-window/lib/publish-growl.library';

/**
 * Hands a running publish job off to a growl when the user closes the loading modal by ANY means — close
 * button, backdrop, or Escape — all of which flip the modal's `isOpen` to false (the panel's close handler
 * only catches the button, so we watch the redux state instead). Gated on
 * `isPublishInFlightForGrowlHandoff()` so it never fires for the other AI-action loading modals, which share
 * this modal id.
 */
export const usePublishDismissWatcher = (): void => {
  const isLoadingModalOpen = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.AI_ACTION_LOADING_MODAL]?.isOpen ?? false;
  });
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (wasOpenRef.current && !isLoadingModalOpen && isPublishInFlightForGrowlHandoff()) {
      handlePublishModalDismissed();
    }
    wasOpenRef.current = isLoadingModalOpen;
  }, [isLoadingModalOpen]);
};
